import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
          <span className="h-px w-6 bg-primary-400" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}